// Components
const ModalPreviewReportedContent = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-preview-reported-content"*/ '@/app/views/main-view/social/components/modals/modal-preview-reported-content/modal-preview-reported-content.vue');

// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';

// Services
import SocialClubService from '@/app/services/main/social-club/social-club-service';

// Constants
import { STATUS_CODES, CONTENT_STATUS } from '@/app/constants/constants';

export default {
	name: 'SocialViewClubAdminTabComponent',
	components: {
		ModalPreviewReportedContent
	},
	mixins: [
		tableMixins,
		toastMessageMixins,
		dateMixins,
		inputTextMixins
	],
	props: {
		groupId:{
			type: Number,
			required: true
		}
	},
	data() {
		return {
			isAPILoading: true,
			// table
			theads: [
				{ name: 'Reporter', sortLabel: 'reporter', isDesc: false, style: null},
				{ name: 'Content Type', sortLabel: 'contentType', isDesc: false, style: null},
				{ name: 'Date and Time Reported', sortLabel: 'createdAt', isDesc: true, style: null},
				{ name: 'Reason', sortLabel: 'reason', isDesc: false, style: null},
				{ name: 'Status', sortLabel: 'status', isDesc: false, style: null},
			],
			// sorting
			sortBy: 'createdAt',
			desc: true,
			// filter
			contentTypeList: ['POST','COMMENT'],
			statusList: [{id: 'PENDING', name: 'Pending Request'}, {id: 'ACTIVE', name: 'Removed Content'}, {id: 'INACTIVE', name: 'Remained Content'}],
			filterReporter: '',
			selectedContentType: '',
			selectedStatus: ''
		}
	},
	watch: {
		filterReporter() {
			this.delayTyping(() => {
				// params true is used to set the page to 1
				this.getTableContent(true);
			});
		},
		selectedContentType() {
			// params true is used to set the page to 1
			this.getTableContent(true);
		},
		selectedStatus() {
			// params true is used to set the page to 1
			this.getTableContent(true);
		}
	},
	created() {
		this.getTableContent();
	},
	methods: {
		showPendingModal(content) {
			// set the modal content for reported preview and show modal
			this.$refs.modalPreviewContent.show(content, this.groupId);
		},
		getTableContent( fromFilter = false, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page;
			this.getReportedList({ page, limit, sortBy, desc });
		},
		getReportedList(queryParams) {
			// append query params when filter is not blank
			if (this.filterReporter) {
				queryParams['f_reporter'] = this.filterReporter;
			}
			if (this.selectedContentType) {
				queryParams['f_contentType'] = this.selectedContentType;
			}
			if (this.selectedStatus) {
				queryParams['f_status'] = this.selectedStatus.id;
			}
		
			this.isAPILoading = true;
			// Call API service to get the table content
			SocialClubService.getAdminReported(this.groupId, queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};
					} else {
						const { ERROR_GET_REPORTED_LIST } = this.toastMessages.report();
						this.showAPIErrorToast(ERROR_GET_REPORTED_LIST, res);
					}
					this.isAPILoading = false;
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAPILoading = false;
				});
		},
		handleRefreshTable() {
			this.getTableContent();
		},
		getClassByStatus(status) {
			switch (status) {
				case CONTENT_STATUS.APPROVED: {
					return 'badge-danger';
				}
				case CONTENT_STATUS.DISAPPROVED: {
					return 'badge-success';
				}
				case CONTENT_STATUS.PENDING: {
					return 'badge-primary';
				}
			}
		}
	}
}